import type { IAction } from "./IAction";

export class DefaultActions {
    public static AddAction: IAction = {
        caption: "Gui.Buttons.Add",
        icon: "plus",
    };

    public static EditAction: IAction = {
        caption: "Gui.Buttons.Edit",
        icon: "pencil",
    };

    public static DeleteAction: IAction = {
        caption: "Gui.Buttons.Delete",
        icon: "trash",
    };
}
